export function autoLink(value: string): string {
	// eslint-disable-next-line max-len
	let re = /(?!\S*(\.png|\.gif|.gif?dl=0|.png?dl=0|jpg?dl=0|JPG?dl=0|socs\.wftodo|d.pr|dl\.dropboxuser|dropbox.com\/s|dropbox.com\/transfer|files.taxi|wffiles.be|cloud\.winfakt|\.jpg|wfsend.s3\/i\/))((https?:)\/\/[a-z0-9&#%=.\/\-?_()]+)[^.]/gi;
	let subst = '<a href="$&" target="_blank" class="w-link">$&</a>';
	return value.replace(re, subst);
}